export enum LikeType {
  like = '1',
  care = '2',
  helpful = '3',
}
